export const checkOnlineStatus = async (): Promise<boolean> => {
  try {
    const response = await fetch('/api/health', {
      cache: 'no-store'
    });
    if (response.status < 200 || response.status >= 300) throw new Error('offline');
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};